// @flow
export { default } from './FocusTrap';
